import { render } from "./Suggestions.vue?vue&type=template&id=4d7a8270&scoped=true"
import script from "./Suggestions.vue?vue&type=script&lang=js"
export * from "./Suggestions.vue?vue&type=script&lang=js"

import "./Suggestions.vue?vue&type=style&index=0&id=4d7a8270&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7a8270"]])

export default __exports__